module.exports = __webpack_public_path__ + "static/media/logo-dark.8ea90838.svg";